<template>
  <v-col md="6">
    <v-card class="neu-glow">
      <v-row class="mx-0 pa-4" justify="space-between" align="center">
        <!-- title and subtitle -->
        <div>
          <div class="text-h6" v-text="$t('Dashboard.headingeBayAccounts')"></div>
        </div>
        <!-- Stats -->
        <div class="d-flex flex-column align-end">
          <v-bottom-navigation
            v-model="showingTasks"
            color="secondary"
            class="neu-glow with-radius"
            height="40"
          >
            <v-btn value="Add" @click="addeBayAccount">
              <span v-text="$t('Dashboard.add')"></span>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </v-row>
      <v-card-text class="py-0">
        <bar-chart v-if="data"
            :data="buildChart"
            :options="settings.bar_option"
            :style="{ height: '300px' }"
            class="pt-5"
            id='Chart'
        />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import colors from "vuetify/lib/util/colors";
import BarChart from "@/components/ChartJS/BarChart";
export default {
  components: { BarChart },
  computed : {
    ...mapGetters(["user","settings","formattedTimeframe","formattedAmount","formattedNumber",'convertedAmount']),
    buildChart(){
      this.data.labels = this.user.d_charts.labels_ebay;
      this.data.datasets=[];
      let charts=['Revenues','Refunds'];
      charts.forEach( e =>
      {                  
        if (this.user.d_charts[e])
        {
          if (this.user.d_charts[e].reduce((a, b) => a + b, 0)>0) 
          {
            let lc={"Revenues":[colors.mygreen.darken2],"Refunds":[colors.mygreen.lighten2],"Unpaids":[colors.blue.base]};
            this.empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
            let mapped=this.user.d_charts[e].map(x => this.convertedAmount(x));
            console.log('mapped_ebay',e,mapped,this.user.d_charts[e]);
            this.empty_dataset.data = this.user.d_charts[e].map(x => this.convertedAmount(x));
            this.empty_dataset.backgroundColor= e=='Revenues'?colors.mygreen.darken2:colors.mygreen.lighten2;
            //this.empty_dataset.gradientFill= lc[e];
            this.data.datasets.push(JSON.parse(JSON.stringify(this.empty_dataset)));
          }
        }
      });
      return this.data;
    },
  },
  data() {
    return {
      namespace: "Dashboard",
      page: "Dashboard",
      loading:false,
      errorid: null,
      search: '',
      showingTasks: "Add",
      totalrevenue: null,
      empty_dataset:
      {
        label: '',
        backgroundColor: colors.mygreen.darken2,
        data: [12, 17, 5, 19],
        shadowOffsetX: 2,
        shadowOffsetY: 4,
        shadowBlur: 8,
        shadowColor: "rgba(66, 165, 245, 0.5)",
        categoryPercentage: 0.5,
        barPercentage: 0.5,
      },
      data: 
      {
        labels: null,
        datasets: null
      },
   };
  },
  methods:{
    addeBayAccount(){
      this.user.ea_dialog=1;
      console.log(this.user);
      this.$router.push('/settings').catch(() => {});
}
  },
  beforeDestroy() {
    this.data = null;
    delete this.data;
  },  
}
</script>